import script from "./BaseBlog.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseBlog.vue?vue&type=script&setup=true&lang=js"

import "./BaseBlog.vue?vue&type=style&index=0&id=1f7fb3af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f7fb3af"]])

export default __exports__